// extracted by mini-css-extract-plugin
export default {"desktopHeader":"Desktop_desktopHeader__ZWThm","wrapper":"Desktop_wrapper__DCWV3","iconContainer":"Desktop_iconContainer__WZgGL","badgeWhite":"Desktop_badgeWhite__Wy4kN"};